import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#1976D2',
                secondary: '#2196F3',
                accent: '#64B5F6',
                background: '#F5F8FB',
                surface: '#E3F2FD',
            }
        }
    }
});
